import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';

interface IProps {
  children: React.ReactNode;
  className?: string;
  overlay?: React.ReactNode;
  size?: number;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
  },
  overlayDefaultPosition: {
    bottom: theme.spacing(0),
    right: theme.spacing(0),
  },
});

/**
 * Används för att visa något över något annat
 */
export const EDOverlay: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = (props: IProps) =>
  props.overlay ? (
    <div className={classNames(props.classes.root, props.className)}>
      {props.children}
      <div
        className={classNames(
          props.classes.overlayDefaultPosition,
          props.classes.overlay
        )}
        style={
          props.size ? { height: props.size, width: props.size } : undefined
        }
      >
        {props.overlay}
      </div>
    </div>
  ) : (
    <div className={classNames(props.className)}>{props.children}</div>
  );

export default withStyles(EDOverlay, styles);
